import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { isAuthenticated, loading, hasRole } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: '16px',
        color: '#94a3b8',
      }}>
        <div className="loader"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si se especifican roles, verificar acceso
  if (roles && roles.length > 0 && !hasRole(...roles)) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        flexDirection: 'column',
        gap: '12px',
        color: '#94a3b8',
        textAlign: 'center',
        padding: '40px',
      }}>
        <span style={{ fontSize: '3rem' }}>🔒</span>
        <h2 style={{ color: '#1e293b', fontSize: '1.2rem', margin: 0 }}>Acceso Restringido</h2>
        <p style={{ fontSize: '0.85rem' }}>No tienes permisos para acceder a esta sección</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
